import { useMaybeModule, useModules } from '@/hooks/useModule'
import { useEffect } from 'react'
import { useLocation } from 'wouter'

export function SendToRoute() {
	const [location, setLocation] = useLocation()
	const modules = useModules()
	const module = useMaybeModule()
	const target = !module && modules.at(0)?.path

	useEffect(() => {
		if (!target) return
		if (location !== target) setLocation(target)
	}, [location, setLocation, target])

	return null
}
